import { Columns } from '@shared/interfaces/table/column-config';
import {ConnectionPointDto} from '@app/api/nts';

export const connectionpointLocationDetailsMasterData: Columns<ConnectionPointDto>[] = [
  {
    title: 'Vejkode',
    key: 'address.streetCode'
  },
  {
    title: 'Vejnavn',
    key: 'address.streetName'
  },
  {
    title: 'Nummer',
    key: 'address.buildingNumber',
  },
  {
    title: 'Etage',
    key: 'address.floorIdentification',
    hideIfNull: true,
  },
  {
    title: 'Dørbetegnelse',
    key: 'address.roomIdentification',
    hideIfNull: true,
  },
  {
    title: 'Bynavn',
    key: 'address.cityName'
  },
  {
    title: 'Postdistrikt',
    key: 'address.postalCode'
  },
  {
    title: 'Kommunekode',
    key: 'address.municipalityCode'
  },
  {
    title: 'Landekode',
    key: 'address.country',
  },
  {
    title: 'DAR-ID',
    key: 'address.darReference'
  },
];
